module.exports = __webpack_public_path__ + "static/bg-min-475ac5fa47bccbd5a1a6e2eb5fe35640.jpg";